import { create } from "zustand";

const useLayoutStore = create((set) => ({
  showingNavMenu: "",
  layoutShowingNavMenu: (showingNavMenu) => set({ showingNavMenu }),
}));

export default useLayoutStore;

